import { Link } from "react-router-dom";

interface LinkItem {
  label: string;
  href: string;
}

const billingLinks: LinkItem[] = [
  { label: "Where is my refund?", href: "/where-is-my-refund" },
  { label: "I don't recognize this charge — what should I do?", href: "/I-dont-recognize-this-charge" },
  { label: "I was unaware of the charges", href: "/I-was-unaware-of-the-charges" },
];

export default function BillingPaymentsSection() {
  return (
    <section className="bg-[#111111]/60 backdrop-blur-sm rounded-2xl border border-white/[0.08] p-6 md:p-8 mb-6">
      <h3 className="text-lg font-semibold text-white mb-2 uppercase tracking-wider flex items-center">
        <span className="mr-2">&#128179;</span>
        BILLING & PAYMENTS
      </h3>
      <p className="text-white/50 text-sm mb-6">
        Get help with charges, refunds, or payment issues.
      </p>
      <div className="space-y-0">
        {billingLinks.map((link, idx) => (
          <Link
            key={link.href}
            to={link.href}
            className={`flex items-center justify-between p-4 hover:bg-white/[0.03] transition-colors cursor-pointer group rounded-lg ${idx < billingLinks.length - 1 ? "border-b border-white/[0.06]" : ""}`}
          >
            <span className="text-white/90 font-medium text-sm md:text-base">{link.label}</span>
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-white/30 group-hover:text-white/60 transition-colors" />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}